const messages = {
  dashboard: {
    title: "Feltarbeiderdashbord",
    description:
      "Velkommen til dashbordet ditt. Her kan du se noverande nøkkeltall og deltakende virksomheter blant kundene dine.",
    overview: {
      title: "Oversikt over deltakende kunder",
      description:
        'Virksomheter som har registrert seg på BRIDGESTONE <span class="text-danger">PLUS</span> og som vi kan knytte til deg via kundenummer.',
      month: "Nye denne måneden",
      year: "Nye dette året",
      all: "Totalt",
    },
    credits: {
      title: "Punktkreditter",
      description:
        "Premiepoeng tildelt deltakende virksomheter på grunnlag av innsendte salgstall.",
      month: "Siste måned",
      year: "Løpende år",
      prev_year: "Totalt",
      allDealers: "Alle forhandlerpoeng",
      allPoints: "Alle poeng",
      prev_month: "Forrige måned",
    },
    details: {
      title: "Deltakende kunder i detalj",
      description:
        'Nedenfor finner du virksomhetene som har registrert seg på BRIDGESTONE <span class="text-danger">PLUS</span> med et Bridgestone-kundenummer og som er tildelt deg som ansvarlig. Bruk sorteringsfunksjonene for en annen rekkefølge eller søkemasken.<br/><br/> <b>Merk:</b> Når du klikker på punktbalansen, kommer du til den detaljerte kontoutskriften.',
    },
    lastImport:
      'Siste import av salgstall: <br/> <span class="text-danger">{date}</span>',
    kickback: {
      description:
        "Deltakende virksomheter krediteres kickback-gebyr på grunnlag av innsendte salgstall.",
    },
    tyres: {
      title: "Dekk",
      description: "Dekk kjøpt av bonusprogramdeltakere",
    },
    short:
      "Velkommen til dashbordet ditt. Her kan du se noverande tall og deltakende virksomheter blant kundene dine.",
    headers: {
      city: "Sted",
      company: "Selskap",
      current_points: "noverande poeng",
      customer_number: "kundenummer",
      details: "detaljer",
      last_login: "Sist innlogget",
      name: "navn",
      postal_code: "Postnummer",
      street: "gate",
      email: "E-post",
    },
    reload: "Last inn på nytt",
    exports: {
      title: "Eksporterte Excel-filer",
      downloadExcel: "Last ned Excel",
      running: "Køyrer",
      head: {
        name: "Namn",
        status: "Status",
      },
    },
  },
};
export default {
  messages,
};
